import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RejectWaterContainerForm";
import {cancelRejectWaterContainer} from "../../../actions/InventoryApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class RejectWaterContainerFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("palletId", this.props.palletId)
                              .set("inventoryId", this.props.serial); 
    return this.props.decommissionWaterContainer(updatedValues.toJS())
      .then((response) => {
        if (response.data.decommissionWaterContainer.errors.length <= 0) {
          this.props.cancelRejectWaterContainer();
        } else {
          let errors = createValidationErrors(response.data.decommissionWaterContainer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRejectWaterContainer();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const DECOMMISSION_WATER_CONTAINER = gql`
  mutation decommissionWaterContainer($data: DecommissionInput!) {
    decommissionWaterContainer(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(DECOMMISSION_WATER_CONTAINER, {
    props: ({ mutate }) => ({
      decommissionWaterContainer: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const RejectWaterContainerFormContainerWithData = withMutation(RejectWaterContainerFormContainer);

export default connect(null, {cancelRejectWaterContainer})(RejectWaterContainerFormContainerWithData);